import { ApiEnums } from '../../Interfaces/ApiEnums';
import { actionCreators } from './CommandsState';

export const getDateCreatedCommandByBatchList = async (
  dispatch: any,
  command: string,
  startDate: string,
  endDate: string
) => {
  return dispatch(actionCreators.getGroupedCommandsByBatchID(command, startDate, endDate));
};

export const getDateCreatedScheduledCommandByBatchList = async (
  dispatch: any,
  command: string,
  startDate: string,
  endDate: string
) => {
  return dispatch(actionCreators.getGroupedScheduledCommandsByBatchID(command, startDate, endDate));
};

export const getCommandByBatchID = async (
  dispatch: any,
  command: string,
  batchID: string
) => {
  return dispatch(actionCreators.getCommandByBatchID(command, batchID));
};

export const getScheduledCommandByBatchID = async (
  dispatch: any,
  command: string,
  batchID: string
) => {
  return dispatch(actionCreators.getScheduledCommandByBatchID(command, batchID));
};

export const clearCommandsByBatchID = async (
  dispatch: any,
  command: string
) => {
  return dispatch(actionCreators.clearCommandsByBatchID(command));
};

export const getAllConfigCommands = async (dispatch: any, startDate: string,
  endDate: string) => {
  return dispatch(actionCreators.getAllConfigCommands(startDate, endDate));
};

export const getAllNBCCommands = async (dispatch: any, startDate: string,
  endDate: string) => {
  return dispatch(actionCreators.getAllNBCCommands(startDate, endDate));
};

export const getConfigCommandByBatchID = async (
  dispatch: any,
  command: string,
  batchID: string
) => {
  return dispatch(actionCreators.getConfigCommandByBatchID(command, batchID));
};

export const getNBCCommandByBatchID = async (
  dispatch: any,
  command: string,
  batchID: string
) => {
  return dispatch(actionCreators.getNBCCommandByBatchID(command, batchID));
};

export const getCommandByDateRange = async (
  dispatch: any,
  command: string,
  startDate: string,
  endDate: string
) => {
  return dispatch(
    actionCreators.getCommandByDateRange(command, startDate, endDate)
  );
};

export const getScheduledCommandByDateRange = async (
  dispatch: any,
  command: string,
  startDate: string,
  endDate: string
) => {
  return dispatch(
    actionCreators.getScheduledCommandByDateRange(command, startDate, endDate)
  );
};

export const updateCommandById = async (
  dispatch: any,
  commandId: number,
  command: ApiEnums.CommandStatus
) => {
  return dispatch(actionCreators.updateCommandById(commandId, command));
};

export const updateScheduledCommandById = async (
  dispatch: any,
  commandId: number,
  command: ApiEnums.ScheduledCommandStatus
) => {
  return dispatch(actionCreators.updateScheduledCommandById(commandId, command));
};

export const updateCommandByBatchId = async (dispatch: any, commandBatchId: any, commandStatus: ApiEnums.CommandStatus) => {
  return dispatch(actionCreators.updateCommandByBatchId(commandBatchId, commandStatus));
}

export const updateScheduledCommandByBatchId = async (dispatch: any, commandBatchId: any, commandStatus: ApiEnums.ScheduledCommandStatus) => {
  return dispatch(actionCreators.updateScheduledCommandByBatchId(commandBatchId, commandStatus));
}

export const resetCommandFetchError = async (dispatch: any) => {
  return dispatch(actionCreators.resetCommandFetchError());
};

export const resetNotificationMessage = async (dispatch: any) => {
  return dispatch(actionCreators.resetNotificationMessage());
};
